import ExportLessonsRequestModelBase from '../_generated/modelBases/export-lessons-request-model-base';

export default class ExportLessonsRequestModel extends ExportLessonsRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
